import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from "@angular/material/form-field";
import { UntilDestroy } from "@ngneat/until-destroy";
import { SolicitudesService } from "src/services/solicitudes.service";
import { UtilsService } from "src/services/utils.service";
import { NotificationsService } from "src/services/notifications.service";
import { CustomizationService } from "src/services/customization.service";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Solicitud } from "src/entity/solicitud";
import { ProgressSpinnerMode } from "@angular/material/progress-spinner";
import * as $ from "jquery";
import { environment } from "src/environments/environment";
import { ClavePinService } from "src/services/clavepin.service";
import { FormStepComponent } from "./forms/form/form-step.component";
import { fadeInUp400ms } from "src/@vex/animations/fade-in-up.animation";
import { OtpStepComponent } from "src/app/shared/ui/otp-step/otp-step.component";
import { PAGES, StatusMap } from "./status-map.model";
import { DeviceInfoService } from "src/services/device-info.service";
import { MatDialog } from "@angular/material/dialog";
import { CustomizationStoreService } from "src/services/customization.store.service";
import { TranslationService } from "src/services/translation.service";
import { WidgetStyles } from "src/entity/customization";
import {
  applyDerivedWidgetStepTexts,
  mergeFlowCustomizationWithDefaults,
} from "src/entity/customization-defaults";
import { LABELS_LANGUAGES } from "../../share/labels.model";
import { SmsFlowService } from "./sms-flow-service.service";
import { WebhooksService } from "src/services/webhooks.service";
import { ScrollService } from "src/services/scroll.service";

@UntilDestroy()
@Component({
  selector: "belender-widget-sms",
  templateUrl: "./sms.component.html",
  styleUrls: ["./sms.component.scss"],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: "standard",
      } as MatFormFieldDefaultOptions,
    },
  ],
  animations: [fadeInUp400ms],
})
export class SmsComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  @Input() data = null;
  @Input() disableActions = false;
  @Input() step = "created";
  @Input() financiadorID;
  @ViewChild("formStep") formComponent: FormStepComponent;
  @ViewChild("otpStep") otpComponent: OtpStepComponent;

  waitingTime = 15;

  private _loading: string | null = null;
  error: any = false;
  vcCode;
  formData;
  packId;
  userId;
  requestID;
  spinnerMode: ProgressSpinnerMode = "indeterminate";
  spinnerValue = 0;
  waitingInterval;

  pusher;
  channel;
  subscribed = false;

  testMode = false;
  cntrlIsPressed = false;
  shiftlIsPressed = false;
  skipCreationOfRequest = false;
  autoAcceptTerms = false;
  currentRequest;
  loaderColor;
  introEnabled = false;
  manual = false;
  pinMode = false;
  requestIDFromURL = false;
  stopPropagationOfSuccess = false;
  paramsSetted = false;
  requestStatus = "loading";
  disableURL = false;
  settingRequestFromBack = false;
  showCancelRequest: boolean = false;
  requestedFromDetail = false;
  env = environment;
  intervalToAskBack = null;
  loadingRequestData = false;
  intervalCount = 0;
  requestedToPin = false;

  deviceInfoDetails$;
  deviceInfoDetails;
  isScaled$;
  isScaled = false;
  termsOpened = false;
  flowName = 'SMS';

  labels = LABELS_LANGUAGES.es;
  currentLang = '';
  funderStyles: WidgetStyles;
  showTermsDialog: boolean = false;
  editable_dates: boolean = false;
  funderConfig;
  warning;

  get loading() {
    return this._loading;
  }

  set loading(value: string | null) {
    this._loading = value;

    if (value !== null) {
      this.onLoadingChanged();
    }
  }

  @ViewChild("formStep") theDiv: ElementRef;
  private orientationChangeHandler: () => void;

  constructor(
    private cd: ChangeDetectorRef,
    private Activatedroute: ActivatedRoute,
    public utils: UtilsService,
    private solicitudesService: SolicitudesService,
    private customizationService: CustomizationService,
    public customizationStoreService: CustomizationStoreService,
    private notis: NotificationsService,
    private pinService: ClavePinService,
    private deviceInfoService: DeviceInfoService,
    public dialog: MatDialog,
    private translationService: TranslationService,
    public smsFlowService: SmsFlowService,
    private scrollService: ScrollService
  ) {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          //@ts-ignore
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp: any) => {
          this.showAlert("otp", otp);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // set deviceInfoDetails data when deviceInfoService complete the request
    this.deviceInfoDetails$ =
      this.deviceInfoService.deviceInfo$.subscribe(
        (info) => {
          if (Object.keys(info).length > 0) {
            this.deviceInfoDetails = info;
          }
        },
      );
  }

  ngOnInit() {
    this.smsFlowService.request_status$.subscribe(status => {
      this.setStatus();
    });

    this.userId = this.customizationStoreService.USER_ID;

    this.smsFlowService.requestID$.subscribe(id => {
      this.requestID = id;
    });

    this.smsFlowService.loading$.subscribe((loading: any) => {
      this.loading = loading;
    });

    // window.screen.orientation listener
    this.getWindowsScreenOrientation();
    const self = this;

    this.packId = this.customizationStoreService.PACK_ID;


    if (environment.env != "pro") {
      $(document).keydown(function (event) {
        if (event.which == 16) {
          this.shiftlIsPressed = true;
        }
        if (event.which == 17) {
          this.cntrlIsPressed = true;
        }
        if (event.which == 84 && this.cntrlIsPressed && this.shiftlIsPressed) {
          self.testMode = !self.testMode;
          self.cd.markForCheck();
        }
      });

      $(document).keyup(function (event) {
        if (event.which == 16) {
          this.shiftlIsPressed = false;
        }
        if (event.which == 16) {
          this.cntrlIsPressed = false;
        }
      });
    }


  }

  ngAfterViewInit(): void {
    this.initFunctions()
  }

  onLoadingChanged() {
    this.scrollUpContent();
  }

  async initFunctions() {
    this.Activatedroute.queryParams.subscribe(async params => {
      if (params && params.request_id) {
        this.smsFlowService.updateRequestID(params.request_id);
      }
      if(params.lang) {
        this.currentLang = params.lang;
        this.smsFlowService.setLoading(this.translationService.getFirstLoading(this.currentLang));
        this.setTranslation();
      } else {
        this.smsFlowService.setLoading(this.labels.loadings.gettingData);
      }

      if (params.editable_dates === 'true') {
        this.editable_dates = params.editable_dates;
      }
      this.userId ? this.setInitialData(this.userId) : this.smsFlowService.setLoading(null);
    })
  }

  setTranslation() {
    let lblx = this.translationService.getLabelsTranslated(this.currentLang);
    if(lblx) this.labels = lblx;
  }

  ngOnDestroy() {
    if (window.screen && window.screen.orientation && this.orientationChangeHandler) {
      window.screen.orientation.removeEventListener('change', this.orientationChangeHandler);
    }
  }

  ngAfterViewChecked(): void {
    this.getWidgetCardHeight();
  }

  getWindowsScreenOrientation() {
    if (window.screen && window.screen.orientation) {
      this.orientationChangeHandler = () => {
        this.getWidgetCardHeight();
      };

      window.screen.orientation.addEventListener('change', this.orientationChangeHandler);
    }
  }

  getWidgetCardHeight() {
    let height = $("#widget-wrapper").height() || 0;
    this.isScaled$ =
    this.deviceInfoService.isScaled$.subscribe(
      (scaled) => {
        this.isScaled = scaled;
        if (this.isScaled) {
          height = height * 1.5;
        }
      },
    );
    this.smsFlowService.sendMessageToParent({ type: "widgetHeight", data: height });
  }

  async setInitialData(userID) {
    //this.customizationService.getCustomization(userID).then(
    await this.validateRequestIdInUrl();
    const flowConfig = mergeFlowCustomizationWithDefaults(
      await this.getFlow(userID)
    );
    this.funderConfig = this.customizationStoreService.FUNDER_CONFIG;
    this.funderStyles = this.customizationStoreService.FUNDER_STYLES;

    this.data = {
      config: this.funderConfig,
      styles: this.funderStyles,
      [this.flowName]: flowConfig
    };
    applyDerivedWidgetStepTexts(this.data, this.flowName);
    if(!this.data.config || !this.data.config.funder_id) {
      this.showAlert(this.labels.warnings.error, this.labels.warnings.noCustomization, 'error');
      this.smsFlowService.setLoading(null);
      this.cd.markForCheck();
      return;
    }
    this.financiadorID = this.data.config.funder_id || "";
    this.disableURL = this.data.config.disableUrlWidget;
    this.introEnabled = this.data.config.introEnabled;
    this.smsFlowService.setLoading(false);
    this.loading = null;
    await this.utils.preloadImages(flowConfig, this.funderStyles);

    this.cd.markForCheck();

    this.smsFlowService.sendMessageToParent({ type: "widgetLoaded", data: {} })

  }

  async getFlow(userID) {
    return new Promise((resolve) => {
      this.customizationService.getCustomizationByFlow(
        userID,
        this.flowName,
        this.currentLang || this.customizationStoreService.LANG,
        this.requestID,
        this.smsFlowService.REQUEST ? this.smsFlowService.REQUEST_STATUS : ''
      ).then(
        (l: any) => {
          if (l?.data) {
            resolve(l.data);
            return;
          }
          resolve(null);
        },
        (e) => {
          resolve(null)
        },
      );
    })
  }

  async validateRequestIdInUrl() {
   return new Promise((resolve) => {
     this.Activatedroute.queryParams.subscribe(
      async (d: any) => {
        if (d) {
          this.setParamsToRequest(d);
          this.smsFlowService.setLoading(false);
        }
        if (d && d["acceptTerms"]) {
          this.paramsSetted = true;
          this.autoAcceptTerms = true;
        }
        if (d["success"]) {
          this.stopPropagationOfSuccess = true;
          this.paramsSetted = true;
        }
        if (d && d.request_id) {
          this.smsFlowService.updateRequestID(d.request_id);
          this.disableURL = false;
          let s = await this.setFormFromVcCode(d.request_id, d);
          this.requestIDFromURL = true;
          this.paramsSetted = true;
          resolve(s)
        } else {
          this.smsFlowService.setLoading(false);
        }
        resolve(null)
      },
      (e) => {
        this.smsFlowService.setLoading(false);
        resolve(null)
      },
    );
   })
  }

  setParamsToRequest(d) {
    if (!this.smsFlowService.REQUEST) {
      this.setRequestStatus("form");
    }

    // 1. Clonar el objeto para trabajar con una nueva referencia (Inmutabilidad)
    // Esto asegura que Angular y los suscriptores reaccionen al cambio.
    let updatedSolicitud = { ...this.smsFlowService.REQUEST };

    if (
      (d["document_number"] || d["document"]) &&
      !updatedSolicitud["person_document_number"]
    ) {
      updatedSolicitud["person_document_number"] =
        d["document_number"] || d["document"];
      this.requestIDFromURL = true;
      this.paramsSetted = true;
    }

    if (
      (d["birth_date"] || d["birthday"]) &&
      !updatedSolicitud["person_birth_date"]
    ) {
      updatedSolicitud["person_birth_date"] = d["birth_date"] || d["birthday"];
      this.requestIDFromURL = true;
      this.paramsSetted = true;
    }

    if (d["phone"] && !updatedSolicitud["person_phone"]) {
      updatedSolicitud["person_phone"] = d["phone"];
      this.requestIDFromURL = true;
      this.paramsSetted = true;
    }

    if (d["email"] && !updatedSolicitud["email"]) {
      updatedSolicitud["email"] = d["email"];
      this.requestIDFromURL = true;
      this.paramsSetted = true;
    }

    this.smsFlowService.setRequest(updatedSolicitud);
  }

  async setFormFromVcCode(vcCode, params) {
    this.showAlert(null)
    this.smsFlowService.setLoading(this.labels.loadings.gettingData);
    this.settingRequestFromBack = true;
    return new Promise((resolve) => {
      this.solicitudesService
      .getSolicitudByCode(vcCode)
      .then((d: any) => {
        if (d && d.data) {
          let requestData = d.data;
          requestData["status_code"] = requestData.consent_process_completed ? "consent_process_completed" : requestData.status_code;
          if (WebhooksService.shouldIgnoreWebhookStatus(requestData.status_code)) {
            if (this.smsFlowService.REQUEST?.status_code) {
              requestData = {
                ...requestData,
                status_code: this.smsFlowService.REQUEST.status_code,
              };
            }
          }
          this.smsFlowService.setRequest(requestData);
          this.setStatus();
          this.smsFlowService.setSubscriptionOfRequest();
          this.smsFlowService.setLoading(false);
          this.skipCreationOfRequest = this.smsFlowService.REQUEST && this.smsFlowService.REQUEST_STATUS && this.smsFlowService.REQUEST_STATUS != 'prerequest';
          if (this.autoAcceptTerms) {
            this.acceptTerms();
          } else {
            this.setParamsToRequest(params);
          }
        } else {
          this.smsFlowService.setLoading(null);
        }
        this.settingRequestFromBack = false;
        resolve(this.smsFlowService.REQUEST || null);
      })
      .catch((e) => {
        this.smsFlowService.setLoading(null);
        this.settingRequestFromBack = false;
        resolve(null);
      });
    })
  }

  setMessageFromTest(o) {
    this.smsFlowService.handlePusherNotification(o);
  }


  addSolicitudPIN(obj) {
    if (this.data[this.flowName] && this.data[this.flowName].packID) {
      obj["package_id"] = this.data[this.flowName].packID;
    }
    this.formComponent.forceEnableDisableInputs({value: true}, {value: true}, {value: true}, {value: true});
    this.pinService
      .addSolicitud(obj)
      .then((d: any) => {
        if (d && d.status && d.status == "error") {
          if (d.message) {
            this.smsFlowService.setRequest(obj);
            //let err = this.handleErrors.getError('ClavePin', 'addRequest', d.errorCode);
            if (d.code == 400 && d.message == "Does not have Pin service") {
              //'Does not have clave pin service') {
              this.setRequestStatus('no_service');
              //this.showAlert('Error!', 'El usuario no tiene servicio!');
              this.smsFlowService.setLoading(false);
            } else if (
              d.code == 400 &&
              d.message == "Incorrect support number"
            ) {
              this.notis.showAlert(this.labels.warnings.error,this.labels.warnings.wrongSupport);
              this.setRequestStatus('form');
            } else if (d.code == 400 && d.message == "Incorrect date") {
              this.showAlert(this.labels.warnings.error, this.labels.warnings.wrongDate);
              this.setRequestStatus('form');
            } else {
              this.setRequestStatus('form');
              this.showAlert(this.labels.warnings.error, d.message);
            }
            this.setStatus();
          }
        } else if (d && d.status && d.status == "success") {
          this.smsFlowService.updateRequestID(d.data.request_id);
          this.smsFlowService.setRequest(d.data);
          let wType = location.pathname;
          if (wType.indexOf("widget-boxed") > -1) {
            location.assign(d.data.widget_url_boxed + "&acceptTerms=true");
          } else {
            location.assign(d.data.widget_url + "&acceptTerms=true");
          }
          this.acceptTerms();
        } else {
          this.showAlert(this.labels.warnings.error, this.labels.warnings.unknownError + d);
        }
      })
      .catch((e) => {
        if (e && e.errorMessage) {
          this.showAlert("Error!", e.errorMessage);
        }
      });
  }

  addSolicitudSMS(obj) {
    this.formComponent.hasDateError = false;
    this.showAlert(null)
    this.solicitudesService
      .addSolicitud(obj)
      .then((d: any) => {
        if (d && d.status && d.status == "error") {
          this.smsFlowService.setRequest(obj);
          if (d.message) {
            if (d.code == 400) {
              if (d.message == "Birthdate incorrect") {
                this.setRequestStatus('form');
                this.formComponent.hasDateError = true;
                this.formComponent.dateError = this.labels.warnings.wrongDateDesc;
              } else if (d.message == "Incorrect date") {
                this.formComponent.hasDateError = true;
                this.formComponent.dateError = this.labels.warnings.wrongDateDesc;
                this.setRequestStatus('form');
              } else {
                this.setRequestStatus('no_service');
                this.smsFlowService.setLoading(false);
              }
            } else {
              if(d.message.phone || d.message === ' Teléfono incorrecto') {
                this.formComponent.disableEnableInputs(true, true, false, true)
              } else {
                this.formComponent.disableEnableInputs(true, false, false, false)
              }
              this.setRequestStatus('form');
              this.showAlert("Error!", d.message);

            }
            this.setStatus();
          }

        } else if (d && d.status && d.status == "success") {
          this.smsFlowService.updateRequestID(d.data.request_id);
          this.smsFlowService.setRequest(d.data);
          this.setStatus();
          this.smsFlowService.setSubscriptionOfRequest();
          this.acceptTerms();
        } else {
          this.showAlert(this.labels.warnings.error,this.labels.warnings.unknownError + d);
        }
      })
      .catch((e) => {
        if (e && e.error) {
          this.showAlert("Error!", e.error);
        }
        this.smsFlowService.setLoading(false);
      });
  }

  validateHaveSmsMode(obj) {
    this.showAlert(null)
    this.solicitudesService
      .checkService(obj)
      .then((d: any) => {
        if (
          d &&
          d.message &&
          d.message.toLowerCase() == "does not have sms service"
        ) {
          this.smsFlowService.setRequest(obj);
          this.setRequestStatus('form');
          this.pinMode = true;
          this.smsFlowService.setLoading(null);
          this.showAlert(this.labels.warnings.noSms, this.labels.warnings.noSmsDesc);
        } else {
          this.addSolicitudSMS(obj);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  public showAlert(title, message?, icon?) {
    this.warning = title ? `<div class="flex flex-col w-full items-start gap-0 pl-2 mr-1"><strong class="text-md" >${title}</strong><small>${message}</small></div>` : null;
  }

  getFunderIconType(type) {
    if(!type || !this.funderStyles) return 'error';
    switch(type) {
      case 'error':
        return this.funderStyles.errorIcon || type;
      case 'success':
        return this.funderStyles.successIcon || type;
      case 'warning':
        return this.funderStyles.warningIcon || type;
      case 'info':
        return this.funderStyles.infoIcon || type;
      default:
        return type;
    }
  }

  public acceptTerms(isLoading: boolean = true) {
    this.showAlert(null)
    let obj = {
      request_id: this.requestID,
      user_id: this.userId,
      terms_and_conditions: true,
      opening: this.termsOpened ? 1 : 0,
    };

    if (Object.keys(this.deviceInfoDetails).length > 0) {
      obj = {
        ...obj, ...{
          ip: this.deviceInfoDetails.ip,
          device: this.deviceInfoDetails.device,
          os: `${this.deviceInfoDetails.os} ${this.deviceInfoDetails.os_version}`,
          resolution: this.deviceInfoDetails.screen
        }
      }
    }

    if (isLoading) {
      this.smsFlowService.setLoading(this.labels.loadings.validatingAndLoginSS);
    }

    this.solicitudesService
      .acceptTerms(obj)
      .then((d: any) => {
        if (d.status && d.status == "error") {
          if (d.message == "You have a request in progress") {
            const wType = location.pathname;
            location.assign(wType.includes("widget-boxed") ? d.response.widget_url_boxed : d.response.widget_url);
          } else if (d.message == "Invalid request status: stand_by") {
            this.setRequestStatus("stand_by");
          } else if (d.message == "Failed to retrieve login status") {
            this.formComponent.forceEnableDisableInputs({value: true}, {value: false}, {value: false}, {value: false});
            this.showAlert("Error!", d.message);
          } else {
            this.showAlert("Error!", d.message || d);
          }
          this.smsFlowService.setLoading(false);
        } else if (d && d.status == "success") {

          this.smsFlowService.sendMessageToParent({ type: "response", data: d.data || d });
          this.smsFlowService.setRequest(d.data);
          this.setStatus();
          this.smsFlowService.setSubscriptionOfRequest();
          this.smsFlowService.setLoading(null);
          this.cd.markForCheck();
        } else {
          this.smsFlowService.setLoading(null);
        }
      })
      .catch((e) => {
        if (e && e.error) {
          this.showAlert("Error!", e.error);
        }
        this.smsFlowService.setLoading(false);
      });
  }

  askToBack() {
    this.solicitudesService
      .getSolicitudByCode(this.requestID)
      .then((d: any) => {
        if (d && d.data) {
          if (WebhooksService.shouldIgnoreWebhookStatus(d.data.status_code)) {
            this.smsFlowService.setLoading(false);
            return;
          }
          this.smsFlowService.setRequest(d.data);
          this.setStatus();
          this.smsFlowService.setLoading(false);
        } else {
          this.smsFlowService.setLoading(false);
        }
      })
      .catch((e) => {
        this.smsFlowService.setLoading(false);
      });
  }

  public setRequestStatus(status) {
    let updatedSolicitud = { ...this.smsFlowService.REQUEST };
    if(!updatedSolicitud) {
      let r = new Solicitud();
      r['status_code'] = status;
      updatedSolicitud = r;
      this.smsFlowService.setRequest(r);
    } else {
      updatedSolicitud['status_code'] = status;
    }
    this.smsFlowService.setRequestStatus(status);
    this.setStatus();
  }

  newRequest(e) {
    this.setRequestStatus('created');
    // ver de eliminar el request id de la url si es que existe
  }

  gotoManual() {
    this.manual = true;
    this.cd.markForCheck();
  }

  goFlow() {
    this.introEnabled = false;
  }

  gotoPin() {
    this.showAlert(null)
    this.requestedToPin = true;
    let obj = {
      request_id: this.smsFlowService.REQUEST.request_id,
    };
    this.smsFlowService.setLoading(this.labels.loadings.smsToPin);
    this.solicitudesService
      .noPhone(obj)
      .then((d: any) => {
        this.smsFlowService.setLoading(null);
        this.setRequestStatus('no_more_phone')
      })
      .catch((e) => {
        console.error(e);
        this.showAlert("Error!", e.message || e);
        this.smsFlowService.setLoading(null);
      });
  }

  public gotoClavePinUrl(request) {
    let isBoxed = location.href.indexOf("widget-boxed") > -1;
    if (isBoxed) {
      location.assign(request.widget_url_boxed);
    } else {
      location.assign(request.widget_url);
    }
  }

  requestStatusFromDetail() {
    this.requestedFromDetail = true;
    this.smsFlowService.setLoading(this.labels.loadings.validatingRequest);
    this.solicitudesService
      .getSolicitudByCode(this.smsFlowService.REQUEST.request_id)
      .then((d) => {
        if (d && d.consent_process_completed) {
          this.setRequestStatus('consent_process_completed');
        } else {
          //this.setRequestStatus('failed_with_retry');
        }
        this.smsFlowService.setLoading(null);
      })
      .catch((e) => {
        this.smsFlowService.setLoading(null);
        this.setRequestStatus('failed');
      });
  }

  public handleRequestStatus(request) {
    // enable this when back it will ready
    let r = new Solicitud();

    if (request.consent_process_completed) {
      this.requestedFromDetail = true;
      let objToSend = {
        "status_message": "El proceso de consentimiento ha finalizado",
        "widget_url": this.smsFlowService.widgetUrl ||  "",
        "status_code": "consent_process_completed",
        "user_id": this.smsFlowService.REQUEST ? this.smsFlowService.REQUEST.user_id : (this.userId || ''),
        "funder_id": this.smsFlowService.REQUEST ? this.smsFlowService.REQUEST.funder_id : "",
        "request_id": this.smsFlowService.REQUEST ? this.smsFlowService.REQUEST.request_id : (this.requestID ||  ""),
        "widget_url_boxed": this.smsFlowService.widgetUrlBoxed ||  ""
      }
      r["status_code"] = "consent_process_completed";
      this.smsFlowService.setRequest(r);
      setTimeout(() => {
        this.smsFlowService.disconnectWebsocket()
      }, 3000);
      this.setStatus();
      if (
        this.data[this.flowName].showDocumentsOnSuccess &&
        !this.intervalToAskBack
      ) {
        this.initIntervalToAskBack();
      }
    } else {
      this.otpComponent && this.otpComponent.resetOtpNumber();
      if (request.otp_status) {
        if (request.otp_status === "VALID") {
          if (request.nex_step_detail) {
            if (request.nex_step_detail.portal === "Seguridad Social") {
              r["status_code"] = "waiting_otp_seguridad_social";

              this.smsFlowService.setRequest(r);
              this.setStatus();
              this.showAlert(null, null);
            }
          }
        } else if (request.otp_status === "INVALID") {
          r["status_code"] = request.status_code;
          this.smsFlowService.setRequest(r);
          this.setStatus();
          this.showAlert(this.labels.warnings.error, this.labels.warnings.wrongOtp);
        }
      } else {
        r["status_code"] = request.status_code || "failed_with_retry";
        this.smsFlowService.setRequest(r);
        this.setStatus();
        this.showAlert(this.labels.warnings.error, this.labels.warnings.wrongOtp);
      }
    }
    this.smsFlowService.setLoading(null);
  }

  initIntervalToAskBack() {
    if (!this.smsFlowService.REQUEST || !this.smsFlowService.REQUEST.request_id) {
      return;
    }

    this.intervalToAskBack = setInterval(() => {
      this.askDetailToBack(this.smsFlowService.REQUEST.request_id);
      this.intervalCount++;
      if (this.intervalCount > 20) {
        this.stopInterval();
      }
    }, 5000);
  }

  stopInterval() {
    this.intervalToAskBack && clearInterval(this.intervalToAskBack);
  }

  askDetailToBack(requestID) {
    let reqID = requestID || this.requestID;
    let currentState = JSON.parse(JSON.stringify(this.smsFlowService.REQUEST_STATUS));

    if (!reqID || currentState === 'consent_process_completed') {
      this.stopInterval();
      return;
    }

    this.pinService
      .getSolicitudByCode(requestID)
      .then((d: any) => {
        if (d && d.data) {
          let requestData = d.data;
          requestData["status_code"] = requestData.consent_process_completed ? "consent_process_completed" : requestData.status_code;
          if (WebhooksService.shouldIgnoreWebhookStatus(requestData.status_code)) {
            return;
          }
          if (currentState != requestData.status_code) {
            this.smsFlowService.setRequest(requestData);
            this.setRequestStatus(this.smsFlowService.REQUEST_STATUS);
          }
        }
      })
      .catch((e) => {
        this.smsFlowService.setLoading(null);
        this.loadingRequestData = false;
      });
  }

  handleBadPhone() {
    this.smsFlowService.disconnectWebsocket();
    this.smsFlowService.setLoading(this.labels.loadings.validatingData);
    setTimeout(() => {
      if (!this.smsFlowService.REQUEST) {
        this.smsFlowService.setRequest(new Solicitud());
      }
      this.setRequestStatus("failed_without_retry")
      this.setStatus();
      this.smsFlowService.setLoading(null);
    }, 3000);
  }

  public setStatus() {
      this.showCancelRequest = true;

      if (this.smsFlowService?.REQUEST) {

        let reqStatus =  this.smsFlowService?.REQUEST.status_code;
        let pageToShow = StatusMap[reqStatus];
        if(pageToShow) {

          if(pageToShow === PAGES.SUCCESS) {
            if (this.funderConfig && this.funderConfig.infiniteLoopInCompleted) {
              this.loading = ' ';
            }
          }

          if (pageToShow === PAGES.PHONE_NO_EXIST) {
            if (this.data && this.data.config && this.data.config.tryPinWithoutSMS) {
              this.showCancelRequest = false;
              this.gotoPin();
              this.requestStatus = PAGES.LOADING;
            } else if (this.data.config.noRetryInBadPhone) {
              this.requestStatus = PAGES.OTP;
            } else {
              this.requestStatus = PAGES.ERROR.DATA;
            }
            return;
          }

          if(pageToShow === PAGES.ABANDONED || pageToShow === PAGES.FAILED) {
            this.showCancelRequest = false;
          }

          if (pageToShow === PAGES.NO_SERVICE) {
            this.requestStatus = pageToShow;
            if (this.data && this.data.config && this.data.config.tryPinWithoutSMS) {
              !this.requestedToPin && this.gotoPin();
              return;
            }
          }

          if (pageToShow === PAGES.BAD_PHONE) {
            if (this.data && this.data.config && this.data.config.tryPinWithoutSMS) {
              !this.requestedToPin && this.gotoPin();
              this.requestStatus = PAGES.NO_PHONE;
              return;
            }
          }
          if (pageToShow === PAGES.NO_PHONE) {
            if (this.data && this.data.config && !this.data.config.tryPinWithoutSMS) {
              this.requestStatus = PAGES.NO_SERVICE;
              return;
            }
            if (this.data && this.data.config && this.data.tryPinWithoutSMS) {
              !this.requestedToPin && this.gotoPin();
              this.requestStatus = PAGES.NO_PHONE;
              return;
            }
          }

          this.requestStatus = pageToShow;
          this.loading = null;
        } else {
          this.requestStatus = PAGES.LOADING;
          this.smsFlowService.setLoading(this.labels.loadings.gettingData);
          this.initIntervalToAskBack();
        }
      }
      this.cd.markForCheck();
  }

  public setStatus2() {
    this.showCancelRequest = true;

    if (this.manual) {
      this.requestStatus = PAGES.MANUAL;
    } else if (this.introEnabled) {
      this.requestStatus = PAGES.INTRO;
    } else if (!this.smsFlowService.REQUEST) {
      this.requestStatus = PAGES.FORM;
    } else if (this.smsFlowService.REQUEST) {

      let reqStatus =  this.smsFlowService.REQUEST_STATUS;
      let pageToShow = StatusMap[reqStatus];

      if (pageToShow) {
        if (pageToShow === PAGES.SUCCESS) {
          // // !this.requestedFromDetail && this.requestStatusFromDetail();
          if (this.data.config && this.data.config.infiniteLoopInCompleted) {
            this.requestStatus = PAGES.LOADING;
            return;
          }
        }

        if (pageToShow === PAGES.ABANDONED || pageToShow === PAGES.FAILED) {
          this.showCancelRequest = false;
        }

        if (pageToShow === PAGES.PHONE_NO_EXIST) {
          if (this.data && this.data.config && this.data.config.tryPinWithoutSMS) {
            this.showCancelRequest = false;
            this.gotoPin();
            this.requestStatus = PAGES.LOADING;
          } else if (this.data.config.noRetryInBadPhone) {
            this.requestStatus = PAGES.OTP;
          } else {
            this.requestStatus = PAGES.ERROR.DATA;
          }
          return;
        }

        if (pageToShow === PAGES.NO_SERVICE) {
          this.requestStatus = pageToShow;
          if (this.data && this.data.config && this.data.config.tryPinWithoutSMS) {
            !this.requestedToPin && this.gotoPin();
            return;
          }
        }
        if (pageToShow === PAGES.BAD_PHONE) {
          if (this.data && this.data.config && this.data.config.tryPinWithoutSMS) {
            !this.requestedToPin && this.gotoPin();
            this.requestStatus = PAGES.NO_PHONE;
            return;
          }
        }

        if (pageToShow === PAGES.NO_PHONE) {
          if (this.data && this.data.config && !this.data.config.tryPinWithoutSMS) {
            this.requestStatus = PAGES.NO_SERVICE;
            return;
          }

          if (this.data && this.data.config && this.data.tryPinWithoutSMS) {
            !this.requestedToPin && this.gotoPin();
            this.requestStatus = PAGES.NO_PHONE;
            return;
          }
        }

        this.requestStatus = pageToShow;

        this.scrollUpContent()
      }
    }
  }

  scrollUpContent() {
    setTimeout(() => {
      this.scrollService.requestScrollMainTop();
    }, 300)
  }

  sendRetry() {}

  gotoTermsAndConditions() {
    // 1. En lugar de abrir un diálogo, simplemente mostramos el componente.
    this.showTermsDialog = true;
  }

  // 2. Nuevo método para manejar la respuesta del componente hijo
  handleTermsResponse(accepted: boolean) {
    // Ocultamos el componente de términos
    this.showTermsDialog = false;

    if (accepted) {
      this.termsOpened = true;
      this.formComponent.setTermsCheck(true);
    }
    // Si no es aceptado, simplemente se cierra.
  }
}
